import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="El problema" className="border-y border-azul/10 bg-ink-2" data-id="element-116" data-mp="2lm0vjedevevm">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: "0px"
    }} data-id="element-117" data-mp="26xeg7cnsan4e">
        <h2 className="text-center font-display text-[25px] font-bold text-white sm:text-4xl" data-id="element-118" data-mp="2bwr0bpn9tg3a">
          ❌ ¿Cuántos kilómetros más vas a perder por culpa de tu cabeza?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center font-display text-lg font-bold text-naranja-soft sm:text-xl" data-id="element-119" data-mp="21z32gqudbsgw">
          Tu cuerpo puede más. Tu mente te detiene antes.
        </p>
        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-120" data-mp="1syn1bo13kxf7">
          Entrenás duro, sumás kilómetros, cuidás la alimentación… y aun así algo te frena cuando
          más lo necesitás. No es el cuerpo. Nunca fue el cuerpo.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-plata" data-id="element-121" data-mp="3nalcvwmvq5e9">
          No es falta de voluntad. No es debilidad. Es que nadie te dio un protocolo mental.
        </p>

        <p className="mt-10 text-center text-xs font-bold uppercase tracking-[0.2em] text-azul-soft" data-id="element-122" data-mp="1u1bwth18xc1k">
          Los 6 errores que comete tu mente antes que tus piernas
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-123" data-mp="23rx2fofc7gtz">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-azul/15 bg-ink p-5" data-id="element-124" data-mp="1g2u9vlj603kp" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-azul/20 text-sm" aria-hidden="true" data-id="element-125" data-mp="30he3fq3dkepc">
                {p.emoji}
              </span>
              <div data-id="element-126" data-mp="1t55biawo11xj">
                <h3 className="text-sm font-bold text-white" data-id="element-127" data-mp="1t5ohct91jzv7">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-128" data-mp="1t7ht2myihaa2">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-129" data-mp="226wf9a7nayor">
          
          
        </div>
      </div>
    </section>;
}